<template>
    <v-layout class="intro" align-center justify-center>
        <div class="typing" v-html="typingMessage"></div>
        <v-layout class="countdown" align-center justify-center>
            <svg
                class="progress-ring"
                width="95"
                height="95">
                <circle
                    ref="circle"
                    class="progress-ring__circle"
                    stroke="#ff9700"
                    stroke-width="5"
                    fill="transparent"
                    r="45"
                    cx="47.5"
                    cy="47.5"/>
            </svg>
            <span>{{ count !== 0 ? count : 'START' }}</span>
        </v-layout>
    </v-layout>
</template>

<script>
    export default {

        data() {
            return {
                round: {
                    1: '지금부터 당신의 한 번 뿐인 인생을 시작합니다.',
                    2: '당신은 인생을 한 번 더 살 수 있는 \n' +
                        '마지막 기회를 얻었습니다.',
                },
                typingMessage : '',
                count: 0,
                progress: 0,
                typingInterval: null,
                countInterval: null,
            }
        },

        beforeDestroy() {

            if (this.typingInterval) {
                clearInterval(this.typingInterval)
            }
            if (this.countInterval) {
                clearInterval(this.countInterval)
            }

            this.$eventBus.$off('START_INTRO')
        },

        mounted() {
            String.prototype.toKorChars = function() {
                let cCho = [ 'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ' ],
                    cJong = [ '', 'ㄱ', 'ㄲ', 'ㄳ', 'ㄴ', 'ㄵ', 'ㄶ', 'ㄷ', 'ㄹ', 'ㄺ', 'ㄻ', 'ㄼ', 'ㄽ', 'ㄾ', 'ㄿ', 'ㅀ', 'ㅁ', 'ㅂ', 'ㅄ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ' ], cho, jung, jong;
                let str = this,
                    cnt = str.length,
                    chars = [],
                    cCode;
                for (let i = 0; i < cnt; i++) {
                    cCode = str.charCodeAt(i);
                    if (cCode === 32) {
                        chars.push(" ");
                        continue;
                    }
                    if (cCode < 0xAC00 || cCode > 0xD7A3) {
                        chars.push(str.charAt(i)); continue;
                    }
                    cCode = str.charCodeAt(i) - 0xAC00;
                    jong = cCode % 28;
                    jung = ((cCode - jong) / 28 ) % 21
                    cho = (((cCode - jong) / 28 ) - jung ) / 21
                    chars.push(cCho[cho]);
                    chars.push(String.fromCharCode( 44032 + (cho * 588) + (jung  * 28)));
                    if (cJong[jong] !== '') {
                        chars.push(String.fromCharCode( 44032 + (cho * 588) + (jung  * 28) + jong ));
                    }

                }

                return chars;
            }

            this.$eventBus.$on('START_INTRO', this.startTyping)
            this.setProgress(0)

        },

        methods: {
            startTyping() {
                if (!this.$userData.round) {
                    setTimeout(_ => {
                        this.startTyping()
                    }, 500)
                    return
                }
                const self = this

                const round = this.$userData.round

                let message = self.round[round]
                let typeing1=[];
                message = message.split('');

                for(let i =0; i<message.length; i++){
                    typeing1[i]=message[i].toKorChars();
                }

                let i=0, j=0, text = '', imax = typeing1.length;
                self.typingInterval = setInterval(typing,60);
                setTimeout(_ => {
                    this.$playAudio(5)
                }, 60)


                function typing(){
                    if(i<=imax-1){
                        let jmax = typeing1[i].length;
                        self.typingMessage = (text + typeing1[i][j]).replace(/\n/g, '<br />');
                        j++;

                        if(j===jmax){
                            text+=  typeing1[i][j-1];
                            i++;
                            j=0;
                        }
                    } else{
                        clearInterval(self.typingInterval);
                        self.typingInterval = null
                        self.countdown()
                        setTimeout(_ => {
                            self.$stopAudio(5)
                        }, 10)
                    }
                }
            },

            setProgress(percent) {
                const circle = this.$refs.circle
                const radius = circle.r.baseVal.value;
                const circumference = radius * 2 * Math.PI;

                circle.style.strokeDasharray = `${circumference} ${circumference}`;
                circle.style.strokeDashoffset = `${circumference}`;

                const offset = circumference - percent / 100 * circumference;
                circle.style.strokeDashoffset = offset;
            },

            countdown() {

                const self = this

                this.count = 3

                setTimeout(_ => {
                    $('.typing').fadeOut(_ => {

                        setTimeout(_ => {
                            this.$playAudio(7)
                        }, 200)

                        $('.countdown').css('visibility', 'visible')

                        $('.progress-ring__circle').css('transition', '0.95s stroke-dashoffset');
                        setTimeout(_ => {
                            self.setProgress(100)
                        }, 10)

                        self.countInterval = setInterval(_ => {

                            setTimeout(_ => {
                                $('.progress-ring__circle').css('transition', '');
                                self.setProgress(0)
                            }, 50)

                            if (self.count === 1) {
                                clearInterval(self.countInterval)
                                self.countInterval = null
                                setTimeout(_ => {
                                    this.$stopAll()
                                    self.$eventBus.$emit('INTRO_ENDED')
                                }, 1500)
                            } else {

                                setTimeout(_ => {
                                    $('.progress-ring__circle').css('transition', '0.95s stroke-dashoffset');
                                    self.setProgress(100)
                                }, 100)

                            }

                            setTimeout(_ => {
                                self.count--
                            }, 100)
                        }, 900)
                    })
                }, 1000)
            }
        }
    }
</script>

<style lang="scss" scoped>

    .intro {
        position: absolute;
        left: 0; right: 0;
        top: 0; bottom: 0;
        background: #19162a;
        font-family: GmarketSans, sans-serif;
        font-size: 22px;
        font-weight: 500;
        letter-spacing: 0.02px;
        color: #ff9700;

        .typing {
            display: inline-block;
            box-sizing: border-box;
            padding-right: 3px;
            text-align: center;

            &:after {
                content: ' ';
                display: inline;
                animation: cursor 0.4s infinite;
                line-height: 0;
                margin-left: 3px;
                font-size: 22px;
            }
        }

        .countdown {
            position: absolute;
            display: flex;
            visibility: hidden;

            .progress-ring__circle {
                // axis compensation
                transform: rotate(-90deg);
                transform-origin: 50% 50%;
            }

            span {
                position: absolute;
                font-family: Pixellari, sans-serif;
                font-size: 57px;
                font-weight: bold;
                color: #ff9700;
                height: 57px;
                line-height: 1.15;
            }
        }
    }



    @keyframes cursor{
        0%{border-right: 1px solid rgba(0,0,0,0)}
        50%{border-right: 1px solid rgba(255,255,255,1)}
        100%{border-right: 1px solid rgba(0,0,0,0)}
    }
</style>
